/* eslint-disable import/order */
import React from 'react';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { projectDirectoryRedirectRoute } from '@jira/router-routes__classic-projects-routes/src/projectDirectoryRedirectRoute.tsx';
import { ScreenRedirect } from '@jira/platform__routing-screen-redirect/src/ui/ScreenRedirect.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const ProjectsDirectoryRedirect = () => <ScreenRedirect to="/jira/projects" />;

export const projectDirectoryRedirectRouteEntry: Route = createEntry(
	projectDirectoryRedirectRoute,

	() => ({
		group: 'classic-software',
		// eslint-disable-next-line no-restricted-syntax
		component: ProjectsDirectoryRedirect,
		layout: globalLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		isRedirect: true,
		resources: [...getNavigationResources()],
		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
